"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useGetTransactionsQuery = exports.transactionApi = void 0;
var react_1 = require("@reduxjs/toolkit/query/react");
var baseQueryWithReauth_1 = require("../../utils/baseQueryWithReauth");
var client_scoped_query_1 = require("../../utils/client-scoped-query");
exports.transactionApi = (0, react_1.createApi)({
    reducerPath: "transactionApi",
    baseQuery: (0, baseQueryWithReauth_1.baseQueryWithReauth)(process.env.API_URL),
    tagTypes: ["transaction"],
    endpoints: function (builder) { return ({
        getTransactions: builder.query({
            queryFn: (0, client_scoped_query_1.clientScopedQueryFn)("/v1/transaction"),
            providesTags: ["transaction"],
        }),
    }); },
});
exports.useGetTransactionsQuery = exports.transactionApi.useGetTransactionsQuery;
